import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@material-ui/core";
import { ExpandMore } from "@mui/icons-material";

export default function Accordion({ title, children }) {
  return (
    <Grid item xs={12}>
      <MuiAccordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="h3">{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            {children}
          </Grid>
        </AccordionDetails>
      </MuiAccordion>
    </Grid>
  );
}
